export default "__VITE_ASSET__ZySe9yea__"